import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';



import '../styles/components/model.scss';

import dark from '../assets/dark-vr.jpg';



export default class Model extends Component {

    render() {

        return (
          <div className="model">
            <div className="image-area">
              <div className="image-group">
                <img  src={ dark } alt='Robocall Image' />
              </div>
              <div className="info">
                <span className="info-title">Explore New Realities</span>
                <p>Play some of the most highly anticipated titles coming soon to VIVE including an all-new STAR WARS&trade; Battlefront&trade;</p>
                <div className="more">
                  <span />
                  <Link to='/'><p>Learn More</p></Link>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
